let API_HEADER = '';
let LOGIN_HEADER = '';
let IMG_HEADER = '';
const istest = process.env.NODE_ENV === 'test';
if (process.env.NODE_ENV === 'production') {
  API_HEADER = projectConfig.API_HEADER || '';
  LOGIN_HEADER = projectConfig.LOGIN_HEADER || 'http://sso.xyabcd.com/ssoauth';
  IMG_HEADER = 'https://fileserver.xyabcd.com';
} else if (istest) {
  API_HEADER = 'http://test.bigdatadisplaysystem.com';
  LOGIN_HEADER = 'http://test.ssoauth.com/ssoauth';
  IMG_HEADER = 'https://fileserver.xyabcd.com';
  //API_HEADER ='http://localhost/bigdatadisplaysystem_php/back'
} else {
  // LOGIN_HEADER = 'http://sso.xyabcd.com/ssoauth';
  LOGIN_HEADER = 'http://test.ssoauth.com/ssoauth';
  // LOGIN_HEADER = 'http://192.168.0.226:30006/ssoauth';
  // API_HEADER = 'http://test.bigdatadisplaysystem.com';
  API_HEADER = '/bigdatadisplaysystem_php/back';
  IMG_HEADER = 'https://fileserver.xyabcd.com';
}

export default {
  logIn: LOGIN_HEADER + '/oauth/authorize',
  logOut: LOGIN_HEADER + '/j_spring_security_logout?redirect_uri=',
  host: API_HEADER,
  weather: 'https://restapi.amap.com/v3/weather/weatherInfo',
  getProjects: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=getProject',
  deleteProject: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=delProject',
  addProject: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=addProject',
  modifyProject: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=modifyProject',
  modifyProject_statues: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=modifyProject_status',
  getApiCollections: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=getapi',
  getUserProjects: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=getUserProject',
  registerUser: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=adduser',
  imageUpload: API_HEADER + '/gthmmc/index.php?m=bdds&c=uploadWeb&a=imageUpload',
  videoUpload: API_HEADER + '/gthmmc/index.php?m=bdds&c=uploadWeb&a=videoUpload',
  getFilesList: API_HEADER + '/gthmmc/index.php?m=bdds&c=uploadWeb&a=getBgmaterial',
  getUserInfo: API_HEADER + '/gthmmc/index.php?m=bdds&c=dataMange&a=oauthGetUser',

  addTemplate: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=addtemplate',
  delTemplate: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=deltemplate',
  modTemplate: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=modifytemplate',
  getPubTemplate: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=gettemplate',
  getPrvTemplate: API_HEADER + '/gthmmc/index.php?m=bdds&c=index&a=getprivatetemplate',
  // 图片上传
  templateImageUpload: IMG_HEADER + '/presignedUrl?sysName=emercontrol',
  removeImageUpload: IMG_HEADER + '/removeUploadFile?sysName=emercontrol',
};
